import {https,httpsFile} from './http.js';
export function index(data,page,currentpage){
    return https().get(`po-headers?page=${page}&currentpage=${currentpage}&date_from=${data.dateFrom}&date_to=${data.dateTo}&supplier_from=${data.supplierFrom}&supplier_to=${data.supplierTo}&company=${data.company}&status=${data.status}`);
}

export function show(header){
    return httpsFile().get(`po-headers/${header}`)
}